module.exports = import("https://cdn.jsdelivr.net/npm/marked/lib/marked.esm.js");;